import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// State
import {
  isDiscountCashbackSystemSelector,
  isGiftsCashbackSystemSelector,
} from '../../state/modules/city/selectors';
import { fetchGiftsIsNeeded } from '../../state/modules/sailplay/actions';

// Assets
import article1 from './assets/article1.svg';
import article2 from './assets/article2.svg';

// Config
import config from '../../config';

export default function usePapaBonus() {
  const dispatch = useDispatch();
  const isDiscountCashbackSystem = useSelector(isDiscountCashbackSystemSelector);
  const isGiftsCashbackSystem = useSelector(isGiftsCashbackSystemSelector);
  const list = useSelector(state => state.sailplay.gifts.list);

  const cashbackNumber = isDiscountCashbackSystem ? 2 : 1;
  const isGiftsOpen = isGiftsCashbackSystem && list.length > 0;

  const articles = useMemo(() => {
    return [
      {
        src: article2,
        title: `papabonus.about${cashbackNumber}.article2.title`,
        description: `papabonus.about${cashbackNumber}.article2.description`,
      },
      {
        src: article1,
        title: `papabonus.about${cashbackNumber}.article1.title`,
        description: `papabonus.about${cashbackNumber}.article1.description.${config.legal}`,
      },
    ];
  }, [isDiscountCashbackSystem]);

  useEffect(() => {
    dispatch(fetchGiftsIsNeeded());
  }, []);

  return { articles, cashbackNumber, isGiftsOpen };
}
